export const classes = {
  form: 'flex flex-col',
  heading: 'mb-[30px]',
  newPassword: 'mb-[26px]',
  confirmPassword: 'mb-[52px]',
  backWrapper: 'mt-[22px] flex justify-center',
};
